<div data-testid="cart-panel-section-wrapper">
  <dx-button
    id="cartButton"
    [disabled]="loading || (!itemsInCart && !itemsInCartC2)"
    stylingMode="text"
    icon="carts"
    (onClick)="toggleCart()"
    [elementAttr]="{ 'data-testid': 'cart-panel-btn-toggle' }"
  ></dx-button>
  <span
    *ngIf="!loading && itemsInCart"
    class="badge badge-success badge-cart"
    data-testid="cart-panel-display-count"
    >{{ itemsInCart }}</span
  >
  <span
    *ngIf="!loading && itemsInCart && itemsInCartC2"
    class="badge badge-warning badge-cart-c2"
    data-testid="cart-panel-display-count-c2"
    >{{ itemsInCartC2 }}</span
  >
  <span
    *ngIf="!loading && !itemsInCart && itemsInCartC2"
    class="badge badge-warning badge-cart"
    data-testid="cart-panel-display-count-c2-only"
    >{{ itemsInCartC2 }}</span
  >
  <dx-load-indicator
    *ngIf="loading"
    height="12"
    width="12"
    class="badge-loading"
    [elementAttr]="{ 'data-testid': 'cart-panel-display-loading' }"
  ></dx-load-indicator>
</div>
